import { allSettled } from 'q';
import { normalizeFile } from './normalizeFile';

export const resolveFiles = async (files, maxFileSizeMB, contentBase64Encoded, allowedMimeTypes) => {
    if (files.length === 0) {
        return [];
    }

    const results = await allSettled(
        files.map(file => normalizeFile(file, maxFileSizeMB, contentBase64Encoded, allowedMimeTypes)),
    );

    return results.map(result => result.value);
};
